import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Layouts
import Header from "./Layouts/Header/Header";

import Footer from "./Layouts/Footer/Footer";
// import About from "./website/Page/About";
import ScrollToTop from "./ScrollToTop";
import { HomePage } from "./Pages/Home/HomePage";
import ServicePage from "./Pages/Services/ServicePage";
import ContactPage from "./Pages/Contact/ContactPage";
import CertificationPage from "./Pages/veirfy cerrtification/CertificationPage";
import AboutPage from "./Pages/About/AboutPage";
import CompanyCertificationMainpage from "./Pages/veirfy cerrtification/CompanyCertificationMainpage";
 

const Loader = () => {
  return <div className="loader"></div>;
};

const MainContent = () => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <>
          {/* Common Header */}
          <Header />

          {/* Page Routes */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicePage />} />
            <Route path="/contact" element={<ContactPage/>} />
            <Route path="/verify-individual-trainee" element={<CertificationPage/>} />
            <Route path="/verify-company-certification" element={<CompanyCertificationMainpage/>}/>
            <Route path="/about" element={<AboutPage/>} />
            {/* Add more routes here */}
          </Routes>


          
          <Footer />
        </>
      )}
    </>
  );
};

const Router = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MainContent />
    </BrowserRouter>
  );
};

export default Router;
